export const FETCH_SPINNER = "FETCH_SPINNER"
export const FETCH_SPINNER_ASYNC = "FETCH_SPINNER_ASYNC"
export const CREATE_SPINNER_DATA = "CREATE_SPINNER_DATA"
export const CREATE_SPINNER_DATA_ASYNC = "CREATE_SPINNER_DATA_ASYNC"
export const EDIT_SPINNER_DATA = "EDIT_SPINNER_DATA"
export const EDIT_SPINNER_DATA_ASYNC = "EDIT_SPINNER_DATA_ASYNC"
export const REMOVE_SPINNER_DATA = "REMOVE_SPINNER_DATA"
export const REMOVE_SPINNER_DATA_ASYNC = "REMOVE_SPINNER_DATA_ASYNC"
